export default __webpack_public_path__ + "static/media/Patient-Summary.25d1e0ec.svg";